export function pages(site) {
    return safe(() => site['pages']) || [];
}

export function block(container, name) {
    return safe(() => container['blocks'][name]) || {};
}

export function content(container, name) {
    return safe(() => container['contents'][name]) || {};
}

export function present(block, name) {
    let cont = content(block, name);
    switch(cont['type']) {
        case 'link': return cont['url'] ? true : false;
        case 'text': return cont['text'] ? true : false;
        case 'richtext': return cont['richtext'] ? true : false;
        case 'image': return cont['image'] ? true : false;
        default: return false;
    }
}

export function blocklist(block, name) {
    return safe(() => block['blocklists'][name]['blocks']) || [];
}

export function pop(blocklist, fn) {
    let maybe_block = blocklist.pop();
    return maybe_block ? fn(maybe_block) : "";
}

export function image(block, name, size = [null, null]) {
    var content = safe(() => block['contents'][name]) || {};

    if (size.length === 2 && content['type'] === 'image') {
        var [w, h] = size.map(x => x ? x : "_");
        return (content['image'] || "about:blank") + "?" + "d=" + w + "x" + h;
    }

    else if (size.length === 0 || content['type'] === 'svg') {
        return content['image'] || "about:blank";
    }

    else {
        console.warn("Invalid image type or missing params in block: " + block['name']);
        return '#';
    }
}

export function text(block, name) {
    return safe(() => block['contents'][name]['text']) || "";
}

export function richtext(block, name) {
    return safe(() => block['contents'][name]['richtext']) || "";
}

export function url(block, name) {
    return safe(() => block['contents'][name]['url']) || "#";
}

export function safe(f) {
    try {
        return f();
    } catch(e) {
        return undefined;
    }
}

export function style(block, rest = "") {
    let padding = () => {
        let default_pads = [5, 0, 5, 0];
        let block_pads;
        try {
            block_pads = block.style.padding;
        }
        catch(e) {
            block_pads = [0, 0, 0, 0];
        }
        let final_pads = [];
        for(let i = 0; i < default_pads.length; i++){
            final_pads.push(default_pads[i] + block_pads[i]);
        }
        return "padding:" + final_pads.join("em ");
    };

    return [padding(), rest].join(";");
}
